// removed by extract-text-webpack-plugin
module.exports = {"banner":"_3lkC5ZWam9mXNhnUWOUmb3","title":"PlC0PWYSgTBH1heCWIHfq","logo":"_3M3hvMEe4CPG_k7yI0xo-x","copyright":"_2Th3HFdeR_UXk1aWS-86-b"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Footer/style.css
 ** module id = 588
 ** module chunks = 0
 **/